import { render, staticRenderFns } from "./StudioProductFreeSample.vue?vue&type=template&id=303fc866&"
import script from "./StudioProductFreeSample.vue?vue&type=script&lang=ts&"
export * from "./StudioProductFreeSample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports